import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from './Line.module.scss';
export function Line() {
    return _jsx("hr", { className: styles.line });
}
